exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card[data-v-13d46f8e]{box-shadow:0 4px 12px 0 rgba(0,0,0,.14901960784313725);border-radius:0}.userAuthHeader[data-v-13d46f8e]{margin-bottom:12px;font-size:18px;font-weight:700;color:#7d868d}", ""]);

// exports
